import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.25 5.13V3.75a1 1 0 0 0-1-1h-8.5a1 1 0 0 0-1 1v1.38a2 2 0 0 0 .64 1.46L5.6 8.66c.4.37.64.9.64 1.46v2.51a1 1 0 0 0 1.45.9l.94-.48a2 2 0 0 0 1.11-1.79v-1.14a2 2 0 0 1 .64-1.46l2.22-2.07a2 2 0 0 0 .64-1.46Z" })
});
export default SvgFilterIcon;
